import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {
  setPropertyWalkThroughFormStep,
  setPropertyWalkThroughFormData,
  fetchConfigureTypeWalkThroughData,
  validateEndingWalkThroughEarly,
  exitPropertyWalkThroughForm,
} from '../../../store/actions/propertyWalkThroughForm';
import { selectPropertyWalkThroughFormData } from '../../../store/selectors/propertyWalkThroughForm';
import {
  setEasyWalkThroughFormData,
  setEasyWalkThroughFormNextStep,
  fetchWalkThroughServiceList,
  updateWalkthroughChecklist,
} from '../../../store/actions/easyWalkThroughForm';
import { selectSuiteById } from '../../../store/selectors/suites';
import { selectAuthenticatedUser } from '../../../store/selectors/auth';
import Row from '../../Row';
import Col from '../../Col';
import FontAwesomeIcon from '../../Icon';
import '../../../layouts/WithNavigation/Sidebar.scss';
import Lightbox from 'yet-another-react-lightbox';
import Zoom from 'yet-another-react-lightbox/plugins/zoom';
import 'yet-another-react-lightbox/styles.css';
import './ViewAllAreasAndFloorPlan.scss';
import '../../Heading/Heading.scss';
import '../../Documents/Documents.scss';
import './LeftNavigation.scss';
import {
  fetchAreasAndSubAreas,
  fetchAreaData,
  fetchSuiteCheckList,
} from '../../../store/actions/areas';
import { selectLoader } from '../../../store/selectors/loader';
import Loader from '../../Loader';

import Button from '../../Button';

import Overlay from '../../Overlay';
import CompleteWalkthrough from './CompleteWalkThrough';
import { setWalkThroughStatus } from '../../../store/actions/suites';

import { selectWalkThrough } from '../../../store/selectors/walkThrough';

import ReactPlayer from 'react-player';

import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper.scss';
import 'swiper/components/navigation/navigation.scss';
import 'swiper/components/pagination/pagination.scss';
import 'swiper/components/scrollbar/scrollbar.scss';

import SwiperCore, { Navigation, Pagination, Scrollbar, A11y } from 'swiper';
import Checklist from './WalkthroughComponents/Checklist';
import { Areas } from './WalkthroughComponents/Areas';
import { WalkthroughImages } from './WalkthroughComponents/WalkthroughImages';

SwiperCore.use([Navigation, Pagination, Scrollbar, A11y]);

class ViewAllAreasAndFloorPlan extends Component {
  state = {
    showOverlay: false,
    isOpen: false,
    selectedIndex: null,
    open: false,
  };

  async componentDidMount() {
    const {
      propertyWalkThroughFormData,
      onFetchConfigureTypeWalkThroughData,
      onFetchAreasAndSubAreas,
      onFetchSuiteCheckList,
      validateEndingWalkThroughEarly,
    } = this.props;
    onFetchConfigureTypeWalkThroughData(
      propertyWalkThroughFormData.walkthroughId
    );
    onFetchAreasAndSubAreas(propertyWalkThroughFormData.walkthroughId);
    onFetchSuiteCheckList(propertyWalkThroughFormData.walkthroughId);
    validateEndingWalkThroughEarly(propertyWalkThroughFormData.walkthroughId);
  }

  handleSubmit() {
    const {
      onFetchWalkThroughServiceList,
      propertyWalkThroughFormData,
      onSetEasyWalkThroughFormData,
    } = this.props;
    onFetchWalkThroughServiceList(propertyWalkThroughFormData.walkthroughId);
    onSetEasyWalkThroughFormData({
      walkThroughServiceRequestListLoading: true,
    });
    this.setState({ showOverlay: true });
  }

  handleCompleteWalkThrough(signatures) {
    const {
      setWalkThroughStatus,
      propertyWalkThroughFormData,
      onExitPropertyWalkThroughForm,
      user,
    } = this.props;
    let status = {
      WalkthroughId: propertyWalkThroughFormData.walkthroughId,
      PropertyId: propertyWalkThroughFormData.propertyId,
      SuiteId: propertyWalkThroughFormData.suiteId,
      UserId: user.id,
      SignatureList: signatures,
      Status: 'Review',
      SuiteName: propertyWalkThroughFormData.suiteName,
      PropertyName: propertyWalkThroughFormData.propertyName,
      PropertymanagerId: propertyWalkThroughFormData.propertyManagerId,
      ActionUrl: 'app/properties/' + propertyWalkThroughFormData.propertyId,
    };
    setWalkThroughStatus(status);
    onExitPropertyWalkThroughForm();
  }

  handleItemChecked = (item) => {
    const {
      onSetPropertyWalkThroughFormData,
      propertyWalkThroughFormData,
      user,
      onUpdateWalkthroughChecklist,
    } = this.props;
    let walkthroughId = propertyWalkThroughFormData.walkthroughId;
    item = { ...item, ischecked: item.ischecked ? false : true };
    let checkedList =
      propertyWalkThroughFormData.configTypeSaved.walkthroughChecklistItems &&
      propertyWalkThroughFormData.configTypeSaved.walkthroughChecklistItems.map(
        (data) => {
          if (data.id === item.id) {
            return item;
          } else {
            return data;
          }
        }
      );
    onSetPropertyWalkThroughFormData({
      configTypeSaved: {
        ...propertyWalkThroughFormData.configTypeSaved,
        walkthroughChecklistItems: checkedList,
      },
    });
    let params = {
      WalkthroughId: walkthroughId,
      UserId: user.id,
      UnitId: propertyWalkThroughFormData.suiteId,
      ChecklistItems: checkedList,
    };
    onUpdateWalkthroughChecklist(params);

    if (
      propertyWalkThroughFormData.status === 'Self-Guided Walk Through' ||
      propertyWalkThroughFormData.status === 'In Progress Home Only'
    ) {
      let status = {
        WalkthroughId: propertyWalkThroughFormData.walkthroughId,
        SuiteId: propertyWalkThroughFormData.suiteId,
        UserId: user.id,
        Role: user.roles[0].role.name,
        Signature: '',
        Status: 'In Progress Home Only',
      };
      this.props.setWalkThroughStatus(status);
    } else {
      let status = {
        WalkthroughId: propertyWalkThroughFormData.walkthroughId,
        SuiteId: propertyWalkThroughFormData.suiteId,
        UserId: user.id,
        Role: user.roles[0].role.name,
        Signature: '',
        Status: 'In Progress Home',
      };
      this.props.setWalkThroughStatus(status);
    }
  };

  editBasedRoleAndStatus() {
    const { user, propertyWalkThroughFormData } = this.props;
    let status = propertyWalkThroughFormData.status;
    if (user.roles[0].role.name === 'Home Owner') {
      if (
        status === 'Guided Walk Through' ||
        status === 'Self-Guided Walk Through' ||
        status === 'In Progress Home Only' ||
        status === 'In Progress Home' ||
        status === 'Begin' ||
        (propertyWalkThroughFormData.configTypeSaved &&
          propertyWalkThroughFormData.configTypeSaved.configTypeSaved
            .scheduledTime === null &&
          status === 'Begin')
      ) {
        return true;
      } else {
        return false;
      }
    } else {
      if (
        status === 'Guided Walk Through' ||
        status === 'In Progress Home' ||
        status === 'In Progress Home Only' ||
        status === 'Self-Guided Walk Through' ||
        (propertyWalkThroughFormData.configTypeSaved &&
          propertyWalkThroughFormData.configTypeSaved.scheduledTime === null &&
          status === 'Begin')
      ) {
        return true;
      } else {
        return false;
      }
    }
  }

  topStatusBar() {
    const { propertyWalkThroughFormData } = this.props;
    let editable = this.editBasedRoleAndStatus();

    if (propertyWalkThroughFormData.sideBarCheckList) {
      let {
        issuesCreated,
        totalCheckedChecklist,
        totalChecklist,
        totalCompletedItems,
        totalCompletedRooms,
        totalItems,
        totalRooms,
      } = propertyWalkThroughFormData.sideBarCheckList;
      let width = 160 / 100;
      let cwidth = 0;
      let totalchecklist = 0;
      let totalcheckedlist = 0;
      totalcheckedlist = totalCheckedChecklist;
      totalchecklist = totalChecklist;
      if (totalCheckedChecklist !== 0) {
        if (totalcheckedlist === totalchecklist) {
          cwidth = '100%';
        } else {
          let totalCount = (totalCheckedChecklist / totalChecklist) * 100;

          cwidth = totalCount.toString() + '%';
        }
      }
      return (
        <>
          <div className="viewAllAreasAndFloorPlan__topStatusBar">
            <Col md={2} xs={3}>
              <div className="viewAllAreasAndFloorPlan__topStatusBar__viewComponent">
                <div className="viewAllAreasAndFloorPlan__topStatusBar__title">
                  Rooms Complete
                </div>
                <div className="viewAllAreasAndFloorPlan__topStatusBar__count">
                  {totalCompletedRooms + '/' + totalRooms}
                </div>
              </div>
            </Col>
            <Col md={2} xs={3}>
              <div className="viewAllAreasAndFloorPlan__topStatusBar__viewComponent">
                <div className="viewAllAreasAndFloorPlan__topStatusBar__title">
                  Items Complete
                </div>
                <div className="viewAllAreasAndFloorPlan__topStatusBar__count">
                  {totalCompletedItems + '/' + totalItems}
                </div>
              </div>
            </Col>
            <Col md={2} xs={3}>
              <div className="viewAllAreasAndFloorPlan__topStatusBar__viewComponent">
                <div className="viewAllAreasAndFloorPlan__topStatusBar__title">
                  Issues Created
                </div>
                <div className="viewAllAreasAndFloorPlan__topStatusBar__count">
                  {issuesCreated}
                </div>
              </div>
            </Col>
            <Col md={3} xs={0}>
              <div className="viewAllAreasAndFloorPlan__topStatusBar__viewComponent__progressBar">
                <div
                  className="walkThroughSideBar__progressBar"
                  style={{ width: '60%', marginRight: 10 }}
                >
                  <div
                    className="walkThroughSideBar__progressBar--bar"
                    style={{ width: cwidth, height: 15, borderRadius: 2 }}
                  />
                </div>

                {/* <div className='viewAllAreasAndFloorPlan__topStatusBar__count'> {totalcheckedlist + "/" + totalchecklist} </div> */}
                <div className="viewAllAreasAndFloorPlan__topStatusBar__title">
                  % Complete
                </div>
              </div>
            </Col>

            <Col
            // md={3}
            // xs={2}
            >
              {editable ? (
                <Button
                  color="complete_purple"
                  icon={
                    <div style={{ fontSize: 16 }}>
                      <FontAwesomeIcon
                        glyph="check"
                        weight="light"
                        //   size="small"
                      />
                    </div>
                  }
                  label="Complete Walk Through"
                  onClick={() =>
                    propertyWalkThroughFormData.validateEndingWalkThroughEarly
                      ? this.handleSubmit()
                      : window.confirm(
                          'Looks like you have not checked all the checklist items. Are you sure you still want to complete the walk-through?'
                        ) && this.handleSubmit()
                  }
                  size="small"
                  disabled={false}
                  block
                />
              ) : (
                <></>
              )}
            </Col>
          </div>
        </>
      );
    } else {
      return (
        <>
          <div className="viewAllAreasAndFloorPlan__topStatusBar">
            Loading...
          </div>
        </>
      );
    }
  }

  displayLightboxImages = (selectedIndex, type) => {
    const { propertyWalkThroughFormData } = this.props;
    let url;
    url =
      propertyWalkThroughFormData.configTypeSaved.walkThroughMedia[
        selectedIndex
      ].url;
    if (type === 'single') {
      return (
        <Lightbox
          open={isOpen}
          close={() => this.setState({ isOpen: false })}
          slides={[{ src: url }]}
          plugins={[Zoom]}
        />
      );
    } else {
      const slides =
        propertyWalkThroughFormData.configTypeSaved.walkThroughMedia.map(
          (media) => ({ src: media.url })
        );

      return (
        <Lightbox
          open={isOpen}
          close={() => this.setState({ isOpen: false })}
          index={selectedIndex}
          slides={slides}
          plugins={[Zoom]}
          on={{
            view: ({ index }) => this.setState({ selectedIndex: index }),
          }}
        />
      );
    }
  };

  render() {
    const {
      user,
      propertyWalkThroughFormData,
      onSetEasyWlkThroughFormNextStep,
      onSetEasyWalkThroughFormData,
      suite,
      areas,
      onSetPropertyWalkThroughFormStep,
      onFetchAreaData,
      loader,
      onSetPropertyWalkThroughFormData,
    } = this.props;

    let { selectedIndex, isOpen } = this.state;
    let { open } = this.state;
    let edit = this.editBasedRoleAndStatus();
    let width = 260 / 100;
    //226/220
    let cwidth = 0;
    let totalchecklist = 0;
    let totalcheckedlist = 0;
    let areasCheckList = [];
    if (
      propertyWalkThroughFormData.sideBarCheckList &&
      propertyWalkThroughFormData.sideBarCheckList.areasCheckList.length > 0
    ) {
      totalcheckedlist =
        propertyWalkThroughFormData.sideBarCheckList.totalCheckedChecklist;
      totalchecklist =
        propertyWalkThroughFormData.sideBarCheckList.totalChecklist;
      areasCheckList =
        propertyWalkThroughFormData.sideBarCheckList.areasCheckList;
      if (
        propertyWalkThroughFormData.sideBarCheckList.totalCheckedChecklist !== 0
      ) {
        if (totalcheckedlist === totalchecklist) {
          cwidth = '100%';
        } else {
          let totalCount =
            (propertyWalkThroughFormData.sideBarCheckList
              .totalCheckedChecklist /
              propertyWalkThroughFormData.sideBarCheckList.totalChecklist) *
            100;
          cwidth = totalCount.toString() + '%';
        }
      }
    }
    return (
      <div class="main_section">
        <div class="right_part_box">
          {this.topStatusBar()}

          <div class="master_bedroom_section">
            <div class="master_heading">
              {user.roles[0].role.name !== 'Home Owner' &&
              propertyWalkThroughFormData.configTypeSaved &&
              propertyWalkThroughFormData.configTypeSaved.description ? (
                <div></div>
              ) : null}
            </div>
            {loader ? (
              <Row mdCenter>
                {' '}
                <Loader center={true} />{' '}
              </Row>
            ) : (
              <div class="master_bedroom_main_box">
                <div class="master_img">
                  <WalkthroughImages
                    propertyWalkThroughFormData={propertyWalkThroughFormData}
                    showAttachments={(index) =>
                      this.setState({ isOpen: true, selectedIndex: index })
                    }
                  />
                  {isOpen && isOpen === true
                    ? propertyWalkThroughFormData.configTypeSaved &&
                      propertyWalkThroughFormData.configTypeSaved
                        .walkThroughMedia
                      ? propertyWalkThroughFormData.configTypeSaved
                          .walkThroughMedia.length === 1
                        ? this.displayLightboxImages(selectedIndex, 'single')
                        : this.displayLightboxImages(selectedIndex, 'multiple')
                      : null
                    : null}
                </div>

                {open && open === true ? (
                  <Lightbox
                    mainSrc={suite.floorPlanURL}
                    onCloseRequest={() => this.setState({ open: false })}
                  />
                ) : null}

                <div class="master_text">
                  <div className="dedroom_content_box">
                    {propertyWalkThroughFormData.configTypeSaved &&
                    propertyWalkThroughFormData.configTypeSaved.description
                      ? propertyWalkThroughFormData.configTypeSaved.description
                      : ''}
                  </div>

                  <Checklist
                    checklists={
                      propertyWalkThroughFormData.configTypeSaved &&
                      propertyWalkThroughFormData.configTypeSaved
                        .walkthroughChecklistItems
                        ? propertyWalkThroughFormData.configTypeSaved
                            .walkthroughChecklistItems
                        : []
                    }
                    edit={edit}
                    handleItemChecked={this.handleItemChecked}
                  />

                  {suite && suite.floorPlanURL ? (
                    <div
                      className="dedroom_content_box"
                      onClick={() => this.setState({ open: true })}
                    >
                      <div class="title_chack_box">
                        <h3>Floor Plan</h3>
                      </div>
                      <div className="floorPlanimg">
                        <img src={suite.floorPlanURL} alt="" />
                      </div>
                    </div>
                  ) : null}
                </div>
              </div>
            )}
          </div>

          <div class="master_img">
            {propertyWalkThroughFormData.configTypeSaved &&
            propertyWalkThroughFormData.configTypeSaved.walkthroughVideos &&
            propertyWalkThroughFormData.configTypeSaved.walkthroughVideos
              .length > 0 ? (
              <Swiper
                spaceBetween={50}
                slidesPerView={1}
                onSlideChange={() => this.setState({ playingVideo: false })}
                onSwiper={(swiper) => console.log('')}
                navigation={
                  propertyWalkThroughFormData.configTypeSaved.walkthroughVideos
                    .length === 1
                    ? false
                    : true
                }
                pagination={{ clickable: true }}
                // scrollbar={{ draggable: true }}
              >
                {propertyWalkThroughFormData.configTypeSaved.walkthroughVideos.map(
                  (item, i) => (
                    <SwiperSlide>
                      <ReactPlayer
                        url={item.url}
                        width="100%"
                        // height="100%"
                        pip={true}
                        ref="vidRef"
                        controls={true}
                        playing={false}
                      />
                    </SwiperSlide>
                  )
                )}
              </Swiper>
            ) : null}
          </div>
          <div class="dummy_name">
            <div class="dummy_name_title">
              <div
                class="dummy_name_main"
                onClick={
                  user.roles[0].role.name !== 'Home Owner' &&
                  propertyWalkThroughFormData.configTypeSaved &&
                  propertyWalkThroughFormData.configTypeSaved.description
                    ? () => {
                        onSetPropertyWalkThroughFormStep(0);
                        onSetPropertyWalkThroughFormData({
                          title:
                            propertyWalkThroughFormData.configTypeSaved.title,
                          description:
                            propertyWalkThroughFormData.configTypeSaved
                              .description,
                          selectedImage: [
                            ...propertyWalkThroughFormData.configTypeSaved
                              .walkThroughMedia,
                            ...propertyWalkThroughFormData.configTypeSaved
                              .walkthroughVideos,
                          ],
                          checkList:
                            propertyWalkThroughFormData.configTypeSaved
                              .walkthroughChecklistItems,
                          configType: 'Create New',
                          configTypeEdit: true,
                        });
                      }
                    : {}
                }
              >
                <h2>
                  {propertyWalkThroughFormData.title
                    ? propertyWalkThroughFormData.title
                    : propertyWalkThroughFormData.configTypeSaved &&
                        propertyWalkThroughFormData.configTypeSaved.title
                      ? propertyWalkThroughFormData.configTypeSaved.title
                      : 'Easy Occupant Walk Through'}{' '}
                  {'  '}
                  {user.roles[0].role.name !== 'Home Owner' &&
                  propertyWalkThroughFormData.configTypeSaved &&
                  propertyWalkThroughFormData.configTypeSaved.description ? (
                    <svg
                      width="23"
                      height="23"
                      viewBox="0 0 23 23"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M10 4H3C2.46957 4 1.96086 4.21071 1.58579 4.58579C1.21071 4.96086 1 5.46957 1 6V20C1 20.5304 1.21071 21.0391 1.58579 21.4142C1.96086 21.7893 2.46957 22 3 22H17C17.5304 22 18.0391 21.7893 18.4142 21.4142C18.7893 21.0391 19 20.5304 19 20V13"
                        stroke="#A6A6A6"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M17.5 2.50001C17.8978 2.10219 18.4374 1.87869 19 1.87869C19.5626 1.87869 20.1022 2.10219 20.5 2.50001C20.8978 2.89784 21.1213 3.4374 21.1213 4.00001C21.1213 4.56262 20.8978 5.10219 20.5 5.50001L11 15L7 16L8 12L17.5 2.50001Z"
                        stroke="#A6A6A6"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  ) : null}
                </h2>
              </div>
            </div>
          </div>

          <Areas
            areas={areas}
            onFetchArea={(area) => {
              onSetEasyWlkThroughFormNextStep();
              onSetEasyWalkThroughFormData({
                areaId: area.areaId,
                areaName: area.name,
              });
              onFetchAreaData(
                propertyWalkThroughFormData.walkthroughId,
                area.areaId
              );
            }}
          />
        </div>

        <Overlay
          showOverlay={this.state.showOverlay}
          content={
            <CompleteWalkthrough
              headline="Walk Through Review & Confirmation"
              strapline={
                <div
                  style={{
                    display: 'flex',
                    textAlign: 'center',
                    justifyContent: 'center',
                    alignItems: 'center',
                    fontSize: 20,
                  }}
                >
                  <div style={{ color: 'grey', paddingRight: 3 }}>
                    <FontAwesomeIcon glyph="check-circle" size="medium" weight="regular" />
                  </div>
                  <div
                    style={{
                      color: 'grey',
                      paddingRight: 3,
                    }}
                  >
                    {' '}
                    {propertyWalkThroughFormData.sideBarCheckList &&
                    propertyWalkThroughFormData.sideBarCheckList
                      .totalCheckedChecklist
                      ? propertyWalkThroughFormData.sideBarCheckList
                          .totalCheckedChecklist
                      : '0'}
                  </div>
                  of{' '}
                  {propertyWalkThroughFormData.sideBarCheckList &&
                  propertyWalkThroughFormData.sideBarCheckList.totalChecklist
                    ? propertyWalkThroughFormData.sideBarCheckList
                        .totalChecklist
                    : '0'}{' '}
                  items completed
                </div>
              }
              onClose={() => this.setState({ showOverlay: false })}
              handleCompleteWalkThrough={(signatures) =>
                this.handleCompleteWalkThrough(signatures)
              }
            />
          }
        />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  let propertyWalkThroughFormData = selectPropertyWalkThroughFormData(state);
  let suite = selectSuiteById(state, propertyWalkThroughFormData.suiteId);
  return {
    suite,
    propertyWalkThroughFormData,
    user: selectAuthenticatedUser(state),
    areas: state.areas,
    loader: selectLoader(state),
    suiteWalkthrough: selectWalkThrough(state),
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      onSetEasyWlkThroughFormNextStep: setEasyWalkThroughFormNextStep,
      onFetchAreasAndSubAreas: fetchAreasAndSubAreas,
      onSetEasyWalkThroughFormData: setEasyWalkThroughFormData,
      onFetchAreaData: fetchAreaData,
      onSetPropertyWalkThroughFormData: setPropertyWalkThroughFormData,
      onUpdateWalkthroughChecklist: updateWalkthroughChecklist,

      onSetPropertyWalkThroughFormStep: setPropertyWalkThroughFormStep,

      onFetchSuiteCheckList: fetchSuiteCheckList,
      onFetchConfigureTypeWalkThroughData: fetchConfigureTypeWalkThroughData,
      validateEndingWalkThroughEarly,
      setWalkThroughStatus: setWalkThroughStatus,
      onExitPropertyWalkThroughForm: exitPropertyWalkThroughForm,
      onFetchWalkThroughServiceList: fetchWalkThroughServiceList,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ViewAllAreasAndFloorPlan);
